import axios from 'axios';

const headers = {
  Accept: 'application/json',
  'x-api-channel': 'web',
  'x-api-journey': 'FTTH-SALES'
};

axios.defaults.crossDomain = true;

let config = null;
//for cancelling the axios API request if needed.
const CancelToken = axios.CancelToken;
let cancelSearchAutoComplete;

if (window.location.href.indexOf('localhost') > -1) {
  // LOCALHOST
  config = {
    getFilters: (params) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/downloadSpeeds',
        headers: headers,
        params: params
      }),
    getProviderPackages: (
      providerList,
      sortOrder,
      pageOffset,
      filterList,
      sortBy,
      dealType
    ) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/services/v1/web/ftth/sales/eligible/offers?latitude=-26.082796&longitude=27.998472&internetUsage=&peopleConnected=&onlyRecommended=true',
        headers: headers
      }),
    getPackageSuggestions: (latitude, longitude, internetUsage, peopleConnected, onlyRecommended) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/eligible/offers?latitude=${ latitude }&longitude=${ longitude }` + (
          (internetUsage || peopleConnected)
            ? `&internetUsage=${ internetUsage }&peopleConnected=${ peopleConnected }&onlyRecommended=${ onlyRecommended }`
            : ''
        ),
        headers: headers
      }),
    submitLead: (payload) =>
      axios({
        method: 'POST',
        url: '/cloud/rest/services/v1/web/ftth/sales/lead',
        headers: headers,
        data: payload
      }),
    getContractTerm: (payload) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/contractTerms',
        headers: headers,
        params: payload
      }),
    getAdditionalServices: (payload) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/services/v1/web/ftth/sales/eligible/VAS',
        headers: headers
      }),
    isExistingUser: (role, id) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/existing/${ id }?role=${ role }`
      }),
    checkValidOTP: (otp, id, role) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/services/v1/web/ftth/sales/${ id }/${ otp }/validate/otp?role=${ role }`
      }),
    submitOrder: (payload, offerId) =>
      axios({
        method: 'PUT',
        url: `/cloud/rest/services/v1/web/ftth/sales/${ offerId }/order`,
        headers: headers,
        data: payload
      }),
    getProvince: () =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/address/province',
        headers: headers
      }),
    getSalesOrderStatus: (salesOrderNo) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/orders/${ salesOrderNo }`,
        headers: headers
      }),
    getVumareachLocationDetails: (latitude, longitude) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/locationDetails?latitude=${ latitude }&longitude=${ longitude }`,
        headers: headers
      }),
    getVumareachOfferDetails: (packageDetails) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/Vumatel Reach/offerDetails',
        headers: headers,
        params: packageDetails
      }),
    getAutoCompleteForAddress: (searchString, forcedRequest) => {
      if (cancelSearchAutoComplete && !forcedRequest) {
        cancelSearchAutoComplete();
      }

      return axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/autocomplete?provider=SPATIAL-EXCHANGE&input=${ searchString }`,
        headers: headers,
        cancelToken: new CancelToken(
          (canceler) => (cancelSearchAutoComplete = canceler)
        )
      });
    },
    getGeocodeFromAddress: (address) => {
      return axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/geocode?ilsGroups=address_component&ilsLocation=${ address }&ilsResultCount=5`,
        headers: headers
      });
    },
    getEligibilityOffers: (latitude, longitude) => {
      return axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/eligible/offers?latitude=${ latitude }&longitude=${ longitude }`,
        headers: headers
      });
    },
    getRecommendedOffers: () => {
      return axios({
        method: 'GET',
        url: '/cloud/rest/services/v1/web/ftth/sales/recommendation/inputs',
        headers: headers
      });
    },

    submitLeadCampaign: ({
      firstName,
      lastName,
      mobileNumber,
      email,
      campaignName,
      preferredTime,
      mrktIndicator,
      installationAddress,
      additionalComments
    }) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/services/v1/web/ftth/sales/campaign?campaignName=${ campaignName }`,
        headers: headers,
        data: {
          contactFirstName: firstName,
          contactLastName: lastName,
          contactMobilePhoneNumber: mobileNumber,
          contactEmailAddress: email,
          additionalComments: additionalComments || '',
          leadType: 'contactMe',
          mrktIndicator: mrktIndicator,
          installationAddress: installationAddress,
          preferredTime: preferredTime
        }
      }),

    getAddressObject: (obj) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/address',
        headers: headers,
        params: obj
      }),
    getBanksList: () =>
      axios({
        method: 'GET',
        url: '/cloud/api/vetting-manage/loadlookups?lookupsValues=BANK_DETAILS',
        headers: headers
      }),
    createQuoteForNewCustomer: (id, payload) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/sales/fixedline/${ id }/quote`,
        headers: headers,
        data: payload
      }),
    getDropDownValues: () =>
      axios({
        method: 'GET',
        url: '/cloud/api/vetting-manage/loadlookups',
        headers: headers
      }),
    getDropDownValuesFromJson: () =>
      axios({
        method: 'GET',
        url: '../MockData/DropDownValues.json',
        headers: headers
      }),
    getCoutriesValuesFromJson: () =>
      axios({
        method: 'GET',
        url: '../MockData/CountryList.json',
        headers: headers
      }),

    validateBankAccount: (payload) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/services/v1/web/ftth/sales/bank/validate',
        headers: headers,
        params: payload
      }),
    getCountryList: () =>
      axios({
        method: 'GET',
        url: '/cloud/api/vetting-manage/loadlookups?lookupsValues=COUNTRY',
        headers: headers
      }),
    submitOrderdForNewCustomer: (payload, params) =>
      axios({
        method: 'PUT',
        url: '/cloud/rest/sales/fixedline/submitOrder',
        headers: headers,
        data: payload,
        params: params
      }),
    getbranchCode: (bankName) =>
      axios({
        method: 'GET',
        url: `/cloud/api/vetting-manage/${ bankName }/branchCodes`,
        headers: headers
      }),
    getPortalOTP: (username, msisdn) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/services/v1/web/ftth/sales/agent/${ username }/otp/request?phoneNumber=${ msisdn }`,
        headers: headers
      }),
    validatePortalOTP: (username, otp) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/services/v1/web/ftth/sales/agent/${ username }/validation?otp=${ otp }`,
        headers: headers
      }),
    getCustomerOTP: (customerId, payload) =>
      axios({
        method: 'PUT',
        url: `/cloud/rest/services/v1/web/ftth/sales/customer/${ customerId }/otp/request`,
        headers: headers,
        data: payload
      }),
    getLineSpeeds: (latitude, longitude, contractTerm) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/eligible/linespeeds?latitude=${ latitude }&longitude=${ longitude }&contractTerm=${ contractTerm }`,
        headers: headers
      }),
    getHelpMeChoosePlanSpeeds: (internetUsage, peopleConnected) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/recommendation/linespeeds?internetUsage=${ internetUsage }&peopleConnected=${ peopleConnected }`,
        headers: headers
      }),
    getOffers: (latitude, longitude, uploadSpeed, downloadSpeed) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/offers?latitude=${ latitude }&longitude=${ longitude }&uploadSpeed=${ uploadSpeed }&downloadSpeed=${ downloadSpeed }`,
        headers: headers
      })
  };
} else {
  // QA1, UAT, STAG, PROD
  config = {
    getFilters: (params) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/downloadSpeeds',
        headers: headers,
        params: params
      }),
    getProviderPackages: (
      providerList,
      sortOrder,
      pageOffset,
      filterList,
      sortBy,
      dealType
    ) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/sales/fixedline/uniqueProducts?provider=${ providerList }&sortBy=${
          sortBy ? sortBy : 'price'
        }&pageSize=6&sortOrder=${ sortOrder }&pageNumber=${ pageOffset }&dealType=${ dealType }&${ filterList }`,
        headers: headers
      }),
    getPackageSuggestions: (latitude, longitude, internetUsage, peopleConnected, onlyRecommended) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/eligible/offers?latitude=${ latitude }&longitude=${ longitude }` + (
          (internetUsage || peopleConnected)
            ? `&internetUsage=${ internetUsage }&peopleConnected=${ peopleConnected }&onlyRecommended=${ onlyRecommended }`
            : ''
        )
      }),
    submitLead: (payload) =>
      axios({
        method: 'POST',
        url: '/cloud/rest/services/v1/web/ftth/sales/lead',
        headers: headers,
        data: payload
      }),
    getContractTerm: (payload) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/contractTerms',
        headers: headers,
        params: payload
      }),
    getAdditionalServices: (payload) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/services/v1/web/ftth/sales/eligible/VAS',
        headers: headers
      }),
    isExistingUser: (role, id) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/existing/${ id }?role=${ role }`
      }),
    checkValidOTP: (otp, id, role) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/services/v1/web/ftth/sales/${ id }/${ otp }/validate/otp?role=${ role }`
      }),

    submitLeadCampaign: ({
      firstName,
      lastName,
      mobileNumber,
      email,
      campaignName,
      preferredTime,
      mrktIndicator,
      installationAddress,
      additionalComments
    }) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/services/v1/web/ftth/sales/campaign?campaignName=${ campaignName }`,
        headers: headers,
        data: {
          contactFirstName: firstName,
          contactLastName: lastName,
          contactMobilePhoneNumber: mobileNumber,
          additionalComments: additionalComments || '',
          contactEmailAddress: email,
          leadType: 'contactMe',
          mrktIndicator: mrktIndicator,
          installationAddress: installationAddress,
          preferredTime: preferredTime
        }
      }),
    getRecommendedOffers: () => {
      return axios({
        method: 'GET',
        url: '/cloud/rest/services/v1/web/ftth/sales/recommendation/inputs',
        headers: headers
      });
    },
    submitOrder: (payload, offerId) =>
      axios({
        method: 'PUT',
        url: `/cloud/rest/services/v1/web/ftth/sales/${ offerId }/order`,
        headers: headers,
        data: payload
      }),
    getProvince: () =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/address/province',
        headers: headers
      }),
    getSalesOrderStatus: (salesOrderNo) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/orders/${ salesOrderNo }`,
        headers: headers
      }),
    getVumareachLocationDetails: (latitude, longitude) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/locationDetails?latitude=${ latitude }&longitude=${ longitude }`,
        headers: headers
      }),
    getVumareachOfferDetails: (packageDetails) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/Vumatel Reach/offerDetails',
        headers: headers,
        params: packageDetails
      }),
    getAutoCompleteForAddress: (searchString, forcedRequest) => {
      if (cancelSearchAutoComplete && !forcedRequest) {
        cancelSearchAutoComplete();
      }

      return axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/autocomplete?provider=SPATIAL-EXCHANGE&input=${ searchString }`,
        headers: headers,
        cancelToken: new CancelToken(
          (canceler) => (cancelSearchAutoComplete = canceler)
        )
      });
    },

    getGeocodeFromAddress: (address) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/geocode?ilsGroups=address_component&ilsLocation=${ address }&ilsResultCount=5`,
        headers: headers,
        params: address
      }),

    getEligibilityOffers: (latitude, longitude) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/eligible/offers?latitude=${ latitude }&longitude=${ longitude }`,
        headers: headers
      }),

    getAddressObject: (obj) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/sales/fixedline/address',
        headers: headers,
        params: obj
      }),
    getBanksList: () =>
      axios({
        method: 'GET',
        url: '/cloud/api/vetting-manage/loadlookups?lookupsValues=BANK_DETAILS',
        headers: headers
      }),
    createQuoteForNewCustomer: (id, payload) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/sales/fixedline/${ id }/quote`,
        headers: headers,
        data: payload
      }),
    getDropDownValues: () =>
      axios({
        method: 'GET',
        url: '/cloud/api/vetting-manage/loadlookups',
        headers: headers
      }),
    getDropDownValuesFromJson: () =>
      axios({
        method: 'GET',
        url: '/cloud/fibre/sales/MockData/DropDownValues.json',
        headers: headers
      }),
    getCoutriesValuesFromJson: () =>
      axios({
        method: 'GET',
        url: '/cloud/fibre/sales/MockData/CountryList.json',
        headers: headers
      }),
    validateBankAccount: (payload) =>
      axios({
        method: 'GET',
        url: '/cloud/rest/services/v1/web/ftth/sales/bank/validate',
        headers: headers,
        params: payload
      }),
    getCountryList: () =>
      axios({
        method: 'GET',
        url: '/cloud/api/vetting-manage/loadlookups?lookupsValues=COUNTRY',
        headers: headers
      }),
    submitOrderdForNewCustomer: (payload, params) =>
      axios({
        method: 'PUT',
        url: '/cloud/rest/sales/fixedline/submitOrder',
        headers: headers,
        data: payload,
        params: params
      }),
    getbranchCode: (bankName) =>
      axios({
        method: 'GET',
        url: `/cloud/api/vetting-manage/${ bankName }/branchCodes`,
        headers: headers
      }),
    getPortalOTP: (username, msisdn) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/services/v1/web/ftth/sales/agent/${ username }/otp/request?phoneNumber=${ msisdn }`,
        headers: headers
      }),
    validatePortalOTP: (username, otp) =>
      axios({
        method: 'POST',
        url: `/cloud/rest/services/v1/web/ftth/sales/agent/${ username }/validation?otp=${ otp }`,
        headers: headers
      }),
    getCustomerOTP: (customerId, payload) =>
      axios({
        method: 'PUT',
        url: `/cloud/rest/services/v1/web/ftth/sales/customer/${ customerId }/otp/request`,
        headers: headers,
        data: payload
      }),

    getLineSpeeds: (latitude, longitude, contractTerm) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/eligible/linespeeds?latitude=${ latitude }&longitude=${ longitude }&contractTerm=${ contractTerm }`,
        headers: headers
      }),
    getHelpMeChoosePlanSpeeds: (internetUsage, peopleConnected) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/recommendation/linespeeds?internetUsage=${ internetUsage }&peopleConnected=${ peopleConnected }`,
        headers: headers
      }),
    getOffers: (latitude, longitude, uploadSpeed, downloadSpeed) =>
      axios({
        method: 'GET',
        url: `/cloud/rest/services/v1/web/ftth/sales/offers?latitude=${ latitude }&longitude=${ longitude }&uploadSpeed=${ uploadSpeed }&downloadSpeed=${ downloadSpeed }`,
        headers: headers
      })
  };
}
export default config;
